// extracted by mini-css-extract-plugin
module.exports = {"article":"blog-module--article--1A5yh","read-more-wrapper":"blog-module--read-more-wrapper--JU_RY","readMoreWrapper":"blog-module--read-more-wrapper--JU_RY"};